import { apiClient } from "./client";

export async function logReportView(payload) {
  try {
    await apiClient.post("/dash/analytics/report-view", payload, { timeout: 4000 });
  } catch {
  }
}

